export const GT_SIGNUP_CONTINUATION_KEY = "gt_signup_continuation";
export const GT_SIGNUP_UPLOAD_TOKEN_KEY = "gt_signup_upload_token";
export const GT_SIGNUP_COMPANY_ID_KEY = "gt_signup_company_id";
export const GT_SIGNUP_META_KEY = "gt_signup_registration_meta";
export const GT_SIGNUP_BASIC_DETAILS_KEY = "gt_signup_basic_details";
export const GT_SIGNUP_OTP_STATE_KEY = "gt_signup_otp_state";

export type SignupRegistrationMeta = {
  companyName: string;
  email: string;
  headquartersCity: string;
  headquartersCountry: string;
};

export type SignupBasicDetailsDraft = {
  companyName: string;
  name: string;
  designation: string;
  email: string;
  phoneNumber: string;
  phoneCountryCode: string;
  websiteUrl: string;
  acceptedTermsAndPrivacy: boolean;
};

export type SignupOtpState = {
  email: string;
  otp: string;
};

export function readSignupBasicDetailsDraft(): SignupBasicDetailsDraft | null {
  const raw = localStorage.getItem(GT_SIGNUP_BASIC_DETAILS_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as SignupBasicDetailsDraft;
  } catch {
    return null;
  }
}

export function writeSignupBasicDetailsDraft(value: SignupBasicDetailsDraft) {
  localStorage.setItem(GT_SIGNUP_BASIC_DETAILS_KEY, JSON.stringify(value));
}

export function clearSignupBasicDetailsDraft() {
  localStorage.removeItem(GT_SIGNUP_BASIC_DETAILS_KEY);
}

export function readSignupOtpState(): SignupOtpState | null {
  const raw = localStorage.getItem(GT_SIGNUP_OTP_STATE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as SignupOtpState;
  } catch {
    return null;
  }
}

export function writeSignupOtpState(value: SignupOtpState) {
  localStorage.setItem(GT_SIGNUP_OTP_STATE_KEY, JSON.stringify(value));
}

export function clearSignupOtpState() {
  localStorage.removeItem(GT_SIGNUP_OTP_STATE_KEY);
}

export function clearSignupFlowStorage() {
  sessionStorage.removeItem(GT_SIGNUP_CONTINUATION_KEY);
  sessionStorage.removeItem(GT_SIGNUP_UPLOAD_TOKEN_KEY);
  sessionStorage.removeItem(GT_SIGNUP_COMPANY_ID_KEY);
  sessionStorage.removeItem(GT_SIGNUP_META_KEY);
  clearSignupBasicDetailsDraft();
  clearSignupOtpState();
}
